import { DrEntity } from "./dr-entity";


export class ProjectAccessHistoryNode extends DrEntity {
    userName: string;
    role: string;
    firstName: string;
    lastName: string;
    email: string;
    projectName: string;
    projectDescription: string;
    organizationName: string;
    accessTime: string;
    endTime: string;
    ipAddress: string;
    duration: string;
    systemUser: boolean;

    constructor(value?: Partial<ProjectAccessHistoryNode>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
    }
}